import { memo } from "react"
import { useTranslation } from "react-i18next"
import { TextInputV2 } from "src/components"
import { Selection } from "src/components/Selection"
import { SECTOR_OPTIONS, SO_STATUS } from "src/constants"
import { useSalesOrganization } from "src/hooks/useSalesOrganization"
import { useAppDispatch, useAppSelector } from "src/redux/hooks"
import {soSelector, setOutstandingFilter} from 'src/redux/slices/soSlices'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {outstandingFilter} = useAppSelector(soSelector)
  const dispatch = useAppDispatch()
  const role = localStorage.getItem('role-flag')
  const {salesOrgOptions} = useSalesOrganization()

  return (
    <tr style={{backgroundColor: 'white'}}>
      <td>
        <TextInputV2
          placeholder={t('kontrak-soNomor')}
          value={outstandingFilter?.so_number ?? ''}
          onChange={({target}) => dispatch(setOutstandingFilter({...outstandingFilter, so_number: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Order Number')}
          value={outstandingFilter?.order_number ?? ''}
          onChange={({target}) =>
            dispatch(setOutstandingFilter({...outstandingFilter, order_number: target.value}))
          }
        />
      </td>
      <td>
        <Selection
          data={
            role === 'null'
              ? SO_STATUS.map((item) =>
                  item.label === 'SAP Error' ? {...item, label: 'Pending'} : item
                )
              : SO_STATUS
          }
          placeholder={'Status'}
          value={outstandingFilter?.status ?? ''}
          onChange={(status) => dispatch(setOutstandingFilter({...outstandingFilter, status}))}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Sektor')}
          data={SECTOR_OPTIONS}
          value={outstandingFilter?.sector_id ?? ''}
          onChange={(sector_id) => dispatch(setOutstandingFilter({...outstandingFilter, sector_id}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Customer Name')}
          value={outstandingFilter?.customer_name ?? ''}
          onChange={({target}) =>
            dispatch(setOutstandingFilter({...outstandingFilter, customer_name: target.value}))
          }
        />
      </td>
      <td>
        <Selection
          data={salesOrgOptions}
          placeholder={t('Sales Org')}
          value={outstandingFilter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => dispatch(setOutstandingFilter({...outstandingFilter, sales_org_code}))}
        />
      </td>
      <td>
        <TextInputV2
            type="number"
          placeholder={t('Total Kuantum')}
          value={outstandingFilter?.total_quantum ?? ''}
          onChange={({target}) =>
            dispatch(setOutstandingFilter({...outstandingFilter, total_quantum: target.value}))
          }
        />
      </td>
    </tr>
  )
})
